import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { FallbackColor } from '@cbhq/cds-common';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { Box } from '@cbhq/cds-web/layout';
import { Tooltip } from '@cbhq/cds-web/overlays/Tooltip/Tooltip';
import { Pressable } from '@cbhq/cds-web/system/Pressable';

import { useProject } from ':cloud/contexts/ProjectContext';
import { ProjectWithRole } from ':cloud/types/service_proto';
import { getDisplayName } from ':cloud/utils/formatters/naming';
import { AppRoute } from ':cloud/utils/routes';
import { AvatarItem } from ':cloud/widgets/sharedcomponents/AvatarItem';

const SLICE_INDEX = 5;
const COLOR_SCHEMES: FallbackColor[] = ['green', 'teal', 'pink', 'blue', 'purple'];

export function ProjectTeamAvatars() {
  const history = useHistory();
  const { selectedProject } = useProject() as { selectedProject: ProjectWithRole | null };
  const activeUsers = selectedProject?.users || [];

  const handleManagePress = useCallback(() => {
    history.push(AppRoute.Projects.ProjectTeam);
  }, [history]);

  return (
    <Box width={Math.min(activeUsers.length + 1, SLICE_INDEX) * 20 + 30} height={40}>
      <Box position="relative">
        {activeUsers.slice(0, SLICE_INDEX).map((member, index) => {
          const userName = getDisplayName(member);

          return (
            <Tooltip content={userName} key={member.id}>
              <AvatarItem
                initial={userName[0]?.toUpperCase()}
                avatarColor={COLOR_SCHEMES[index % COLOR_SCHEMES.length]}
                index={index}
                key={member.id}
              />
            </Tooltip>
          );
        })}
        <Box
          bordered
          borderColor="transparent"
          borderRadius="roundedLarge"
          position="absolute"
          background="backgroundAlternate"
          left={20 * Math.min(activeUsers.length, SLICE_INDEX)}
          width={32}
          height={32}
          zIndex={1000}
          justifyContent="center"
          alignItems="center"
        >
          <Pressable
            background="transparent"
            onPress={handleManagePress}
            height="100%"
            width="100%"
          >
            <Box justifyContent="center" width="100%">
              <Icon name="add" size="s" color="foreground" />
            </Box>
          </Pressable>
        </Box>
      </Box>
    </Box>
  );
}
